import { render, staticRenderFns } from "./ModalConfirmOrderComponent.vue?vue&type=template&id=40723f2a"
import script from "./ModalConfirmOrderComponent.vue?vue&type=script&lang=js"
export * from "./ModalConfirmOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports